import { render, staticRenderFns } from "./ExampleForm.vue?vue&type=template&id=d2736344&"
import script from "./ExampleForm.vue?vue&type=script&lang=ts&"
export * from "./ExampleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports